import {PING_FOR_ATTRIBUTION_NAME} from '../placements.consts';

export default function isCustomParamOfBooleanType(customParamKey: string) {
  return customParamKey === PING_FOR_ATTRIBUTION_NAME;
}
